module.exports = __webpack_public_path__ + "img/quanwei_bg.67f48237.png";